module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10234.f31c4417.jpg";